var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "el-section eu-justify_center eu-flex" }, [
      _c(
        "div",
        { staticClass: "emd-container eu-flex-item eu-basis_12 eu-basis_8_md" },
        [
          _c(
            "div",
            {
              staticClass:
                "emd-container__content eu-pa_5_md eu-flex eu-justify_center emd-text _align_center",
            },
            [
              _vm._m(0),
              _c(
                "div",
                {
                  staticClass:
                    "eu-flex-item eu-basis_12 eu-basis_12_md eu-mb_5",
                },
                [
                  _c("span", { staticClass: "success-title" }, [
                    _vm._v(_vm._s(_vm.$t("title")) + " " + _vm._s(_vm.total)),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "eu-flex-item eu-basis_12 eu-basis_12_md eu-mb_5",
                },
                [
                  _c("span", { staticClass: "success-subtitle" }, [
                    _vm._v(_vm._s(_vm.$t("subtitle"))),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "eu-flex-item eu-basis_12 eu-basis_9_md eu-mb_5",
                },
                [
                  _c("div", { staticClass: "el-chunk eu-align-items_center" }, [
                    _c("div", { staticClass: "emd-container _type_card" }, [
                      _c("div", { staticClass: "emd-container__content" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "emd-copy eu-justify_center eu-align-items_center eu-row_md",
                          },
                          [
                            _c(
                              "p",
                              {
                                ref: "payment_link",
                                staticClass:
                                  "emd-copy__text eu-grow_0 eu-basis_8_md",
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.paymentLinkData.url) + " "
                                ),
                              ]
                            ),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "emd-btn _color_primary _block_mobile eu-ml_4 eu-basis_3_md",
                                class: { _copied: _vm.copied },
                                on: {
                                  click: function ($event) {
                                    return _vm.copy("payment_link")
                                  },
                                },
                              },
                              [
                                !_vm.copied
                                  ? _c("div", [
                                      _c("i", { staticClass: "uil uil-copy" }),
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("copy")) + " "
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm.copied
                                  ? _c("div", [
                                      _c("i", {
                                        staticClass: "uil uil-check-circle",
                                      }),
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("copied")) + " "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "eu-flex-item eu-basis_12 eu-basis_12_md eu-justify_center eu-flex eu-mb_5",
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "emd-input-icon__link whatsapp-button",
                      attrs: { href: _vm.$sanitize(_vm.whatsappUrl) },
                    },
                    [
                      _c("i", { staticClass: "uil uil-whatsapp" }),
                      _vm._v(" " + _vm._s(_vm.$t("whatsapp")) + " "),
                    ]
                  ),
                ]
              ),
            ]
          ),
          _c("hr", { staticClass: "emd-divider" }),
          _c("section", { staticClass: "el-section" }, [
            _c("div", { staticClass: "eu-flex eu-justify_space-between" }, [
              _c(
                "a",
                {
                  staticClass: "emd-btn _type_text _color_secondary eu-ml_4",
                  attrs: {
                    href: _vm.$sanitize(_vm.viewOrder),
                    target: "_blank",
                    rel: "noopener noreferrer",
                  },
                },
                [
                  _vm._v(" " + _vm._s(_vm.$t("linkDetails")) + " "),
                  _c("i", { staticClass: "uil uil-arrow-up-right" }),
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "emd-btn _color_secondary eu-mr_4",
                  on: { click: _vm.createNewLink },
                },
                [_vm._v(" " + _vm._s(_vm.$t("newLink")) + " ")]
              ),
            ]),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "eu-flex-item eu-basis_12 eu-basis_12_md eu-mb_4" },
      [_c("i", { staticClass: "uil uil-check-circle check-icon" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }